(function () {
  'use strict';

  angular.module('sempraWebapp').factory('locales', localesConfig);
  /* eslint-disable */
  /** @ngInject */
  function localesConfig($translate, $locale) {
    return {
      sr: {
        DATETIME_FORMATS: {
          AMPMS: ['pre podne', 'po podne'],
          DAY: [
            'nedelja',
            'ponedeljak',
            'utorak',
            'sreda',
            '\u010detvrtak',
            'petak',
            'subota'
          ],
          ERANAMES: ['Pre nove ere', 'Nove ere'],
          ERAS: ['p. n. e.', 'n. e.'],
          FIRSTDAYOFWEEK: 6,
          MONTH: [
            'januar',
            'februar',
            'mart',
            'april',
            'maj',
            'jun',
            'jul',
            'avgust',
            'septembar',
            'oktobar',
            'novembar',
            'decembar'
          ],
          SHORTDAY: ['ned', 'pon', 'uto', 'sre', '\u010det', 'pet', 'sub'],
          SHORTMONTH: [
            'jan',
            'feb',
            'mar',
            'apr',
            'maj',
            'jun',
            'jul',
            'avg',
            'sep',
            'okt',
            'nov',
            'dec'
          ],
          WEEKENDRANGE: [5, 6],
          fullDate: 'EEEE, dd. MMMM y.',
          longDate: 'dd. MMMM y.',
          medium: 'dd.MM.y. HH.mm.ss',
          mediumDate: 'dd.MM.y.',
          mediumTime: 'HH.mm.ss',
          short: 'd.M.yy. HH.mm',
          shortDate: 'd.M.yy.',
          shortTime: 'HH.mm'
        },
        NUMBER_FORMATS: {
          CURRENCY_SYM: 'din',
          DECIMAL_SEP: ',',
          GROUP_SEP: '.',
          PATTERNS: [
            {
              gSize: 3,
              lgSize: 3,
              maxFrac: 3,
              minFrac: 0,
              minInt: 1,
              negPre: '-',
              negSuf: '',
              posPre: '',
              posSuf: ''
            },
            {
              gSize: 3,
              lgSize: 3,
              maxFrac: 2,
              minFrac: 2,
              minInt: 1,
              negPre: '-',
              negSuf: '\u00a0\u00a4',
              posPre: '',
              posSuf: '\u00a0\u00a4'
            }
          ]
        },
        id: 'sr-latn',
        pluralCat: function (n, opt_precision) {
          var i = n | 0;
          var vf = getVF(n, opt_precision);
          if (
            (vf.v == 0 && i % 10 == 1 && i % 100 != 11) ||
            (vf.f % 10 == 1 && vf.f % 100 != 11)
          ) {
            return PLURAL_CATEGORY.ONE;
          }
          if (
            (vf.v == 0 &&
              i % 10 >= 2 &&
              i % 10 <= 4 &&
              (i % 100 < 12 || i % 100 > 14)) ||
            (vf.f % 10 >= 2 &&
              vf.f % 10 <= 4 &&
              (vf.f % 100 < 12 || vf.f % 100 > 14))
          ) {
            return PLURAL_CATEGORY.FEW;
          }
          return PLURAL_CATEGORY.OTHER;
        }
      },
      en: {
        DATETIME_FORMATS: {
          AMPMS: ['AM', 'PM'],
          DAY: [
            'Sunday',
            'Monday',
            'Tuesday',
            'Wednesday',
            'Thursday',
            'Friday',
            'Saturday'
          ],
          ERANAMES: ['Before Christ', 'Anno Domini'],
          ERAS: ['BC', 'AD'],
          FIRSTDAYOFWEEK: 6,
          MONTH: [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December'
          ],
          SHORTDAY: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          SHORTMONTH: [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Oct',
            'Nov',
            'Dec'
          ],
          WEEKENDRANGE: [5, 6],
          fullDate: 'EEEE, MMMM d, y',
          longDate: 'MMMM d, y',
          medium: 'MMM d, y h:mm:ss a',
          mediumDate: 'MMM d, y',
          mediumTime: 'h:mm:ss a',
          short: 'M/d/yy h:mm a',
          shortDate: 'M/d/yy',
          shortTime: 'h:mm a'
        },
        NUMBER_FORMATS: {
          CURRENCY_SYM: '$',
          DECIMAL_SEP: '.',
          GROUP_SEP: ',',
          PATTERNS: [
            {
              gSize: 3,
              lgSize: 3,
              maxFrac: 3,
              minFrac: 0,
              minInt: 1,
              negPre: '-',
              negSuf: '',
              posPre: '',
              posSuf: ''
            },
            {
              gSize: 3,
              lgSize: 3,
              maxFrac: 2,
              minFrac: 2,
              minInt: 1,
              negPre: '-\u00a4',
              negSuf: '',
              posPre: '\u00a4',
              posSuf: ''
            }
          ]
        },
        id: 'en',
        pluralCat: function (n, opt_precision) {
          var i = n | 0;
          var vf = getVF(n, opt_precision);
          if (i == 1 && vf.v == 0) {
            return PLURAL_CATEGORY.ONE;
          }
          return PLURAL_CATEGORY.OTHER;
        }
      },
      tw: {
        DATETIME_FORMATS: {
          AMPMS: ['上午', '下午'],
          DAY: [
            '星期日',
            '星期一',
            '星期二',
            '星期三',
            '星期四',
            '星期五',
            '星期六'
          ],
          ERANAMES: ['西元前', '西元'],
          ERAS: ['西元前', '西元'],
          FIRSTDAYOFWEEK: 0,
          MONTH: [
            '一月',
            '二月',
            '三月',
            '四月',
            '五月',
            '六月',
            '七月',
            '八月',
            '九月',
            '十月',
            '十一月',
            '十二月'
          ],
          SHORTDAY: ['週日', '週一', '週二', '週三', '週四', '週五', '週六'],
          SHORTMONTH: [
            '1月',
            '2月',
            '3月',
            '4月',
            '5月',
            '6月',
            '7月',
            '8月',
            '9月',
            '10月',
            '11月',
            '12月'
          ],
          WEEKENDRANGE: [5, 6],
          fullDate: 'y年M月d日 EEEE',
          longDate: 'y年M月d日',
          medium: 'y年M月d日 ah:mm:ss',
          mediumDate: 'y年M月d日',
          mediumTime: 'ah:mm:ss',
          short: 'y/M/d ah:mm',
          shortDate: 'y/M/d',
          shortTime: 'ah:mm'
        },
        NUMBER_FORMATS: {
          CURRENCY_SYM: 'NT$',
          DECIMAL_SEP: '.',
          GROUP_SEP: ',',
          PATTERNS: [
            {
              gSize: 3,
              lgSize: 3,
              maxFrac: 3,
              minFrac: 0,
              minInt: 1,
              negPre: '-',
              negSuf: '',
              posPre: '',
              posSuf: ''
            },
            {
              gSize: 3,
              lgSize: 3,
              maxFrac: 2,
              minFrac: 2,
              minInt: 1,
              negPre: '-\u00a4',
              negSuf: '',
              posPre: '\u00a4',
              posSuf: ''
            }
          ]
        },
        id: 'tw',
        pluralCat: function (n, opt_precision) {
          return PLURAL_CATEGORY.OTHER;
        }
      },
      pl: {
        DATETIME_FORMATS: {
          AMPMS: ['AM', 'PM'],
          DAY: [
            'niedziela',
            'poniedziałek',
            'wtorek',
            'środa',
            'czwartek',
            'piątek',
            'sobota'
          ],
          ERANAMES: ['Before Christ', 'Anno Domini'],
          ERAS: ['BC', 'AD'],
          FIRSTDAYOFWEEK: 6,
          MONTH: [
            'styczeń',
            'luty',
            'marzec',
            'kwiecień',
            'maj',
            'czerwiec',
            'lipiec',
            'sierpień',
            'wrzesień',
            'październik',
            'listopad',
            'grudzień'
          ],
          SHORTDAY: ['ndz', 'pon', 'wt', 'śr', 'czw', 'pt', 'sob'],
          SHORTMONTH: [
            'sty',
            'lut',
            'mar',
            'kwi',
            'maj',
            'cze',
            'lip',
            'sie',
            'wrz',
            'paź',
            'lis',
            'gru'
          ],
          WEEKENDRANGE: [5, 6],
          fullDate: 'EEEE, MMMM d, y',
          longDate: 'MMMM d, y',
          medium: 'MMM d, y h:mm:ss a',
          mediumDate: 'MMM d, y',
          mediumTime: 'h:mm:ss a',
          short: 'M/d/yy h:mm a',
          shortDate: 'M/d/yy',
          shortTime: 'h:mm a'
        },
        NUMBER_FORMATS: {
          CURRENCY_SYM: 'zl',
          DECIMAL_SEP: '.',
          GROUP_SEP: ',',
          PATTERNS: [
            {
              gSize: 3,
              lgSize: 3,
              maxFrac: 3,
              minFrac: 0,
              minInt: 1,
              negPre: '-',
              negSuf: '',
              posPre: '',
              posSuf: ''
            },
            {
              gSize: 3,
              lgSize: 3,
              maxFrac: 2,
              minFrac: 2,
              minInt: 1,
              negPre: '-\u00a4',
              negSuf: '',
              posPre: '\u00a4',
              posSuf: ''
            }
          ]
        },
        id: 'pl',
        pluralCat: function (n, opt_precision) {
          var i = n | 0;
          var vf = getVF(n, opt_precision);
          if (i == 1 && vf.v == 0) {
            return PLURAL_CATEGORY.ONE;
          }
          return PLURAL_CATEGORY.OTHER;
        }
      },
      cs: {
        DATETIME_FORMATS: {
          AMPMS: ['AM', 'PM'],
          DAY: [
            'neděle',
            'pondělí',
            'úterý',
            'středa',
            'čtvrtek',
            'pátek',
            'sobota'
          ],
          ERANAMES: ['Before Christ', 'Anno Domini'],
          ERAS: ['BC', 'AD'],
          FIRSTDAYOFWEEK: 6,
          MONTH: [
            'leden',
            'únor',
            'březen',
            'duben',
            'květen',
            'červen',
            'červenec',
            'srpen',
            'září',
            'říjen',
            'listopad',
            'prosinec'
          ],
          SHORTDAY: ['ne', 'po', 'út', 'st', 'čt', 'pá', 'so'],
          SHORTMONTH: [
            'led',
            'úno',
            'bře',
            'dub',
            'kvě',
            'čvn',
            'čvc',
            'srp',
            'zář',
            'říj',
            'lis',
            'pro'
          ],
          WEEKENDRANGE: [5, 6],
          fullDate: 'EEEE, MMMM d, y',
          longDate: 'MMMM d, y',
          medium: 'MMM d, y h:mm:ss a',
          mediumDate: 'MMM d, y',
          mediumTime: 'h:mm:ss a',
          short: 'M/d/yy h:mm a',
          shortDate: 'M/d/yy',
          shortTime: 'h:mm a'
        },
        NUMBER_FORMATS: {
          CURRENCY_SYM: 'kč',
          DECIMAL_SEP: '.',
          GROUP_SEP: ',',
          PATTERNS: [
            {
              gSize: 3,
              lgSize: 3,
              maxFrac: 3,
              minFrac: 0,
              minInt: 1,
              negPre: '-',
              negSuf: '',
              posPre: '',
              posSuf: ''
            },
            {
              gSize: 3,
              lgSize: 3,
              maxFrac: 2,
              minFrac: 2,
              minInt: 1,
              negPre: '-\u00a4',
              negSuf: '',
              posPre: '\u00a4',
              posSuf: ''
            }
          ]
        },
        id: 'cs',
        pluralCat: function (n, opt_precision) {
          var i = n | 0;
          var vf = getVF(n, opt_precision);
          if (i == 1 && vf.v == 0) {
            return PLURAL_CATEGORY.ONE;
          }
          return PLURAL_CATEGORY.OTHER;
        }
      },
      de: {
        DATETIME_FORMATS: {
          AMPMS: ['vorm.', 'nachm.'],
          DAY: [
            'Sonntag',
            'Montag',
            'Dienstag',
            'Mittwoch',
            'Donnerstag',
            'Freitag',
            'Samstag'
          ],
          ERANAMES: ['v. Chr.', 'n. Chr.'],
          ERAS: ['v. Chr.', 'n. Chr.'],
          FIRSTDAYOFWEEK: 6,
          MONTH: [
            'Januar',
            'Februar',
            'M\u00e4rz',
            'April',
            'Mai',
            'Juni',
            'Juli',
            'August',
            'September',
            'Oktober',
            'November',
            'Dezember'
          ],
          SHORTDAY: ['So.', 'Mo.', 'Di.', 'Mi.', 'Do.', 'Fr.', 'Sa.'],
          SHORTMONTH: [
            'Jan.',
            'Feb.',
            'M\u00e4rz',
            'Apr.',
            'Mai',
            'Juni',
            'Juli',
            'Aug.',
            'Sep.',
            'Okt.',
            'Nov.',
            'Dez.'
          ],
          WEEKENDRANGE: [5, 6],
          fullDate: 'EEEE, d. MMMM y',
          longDate: 'd. MMMM y',
          medium: 'dd.MM.y HH:mm:ss',
          mediumDate: 'dd.MM.y',
          mediumTime: 'HH:mm:ss',
          short: 'dd.MM.yy HH:mm',
          shortDate: 'dd.MM.yy',
          shortTime: 'HH:mm'
        },
        NUMBER_FORMATS: {
          CURRENCY_SYM: '\u20ac',
          DECIMAL_SEP: ',',
          GROUP_SEP: '.',
          PATTERNS: [
            {
              gSize: 3,
              lgSize: 3,
              maxFrac: 3,
              minFrac: 0,
              minInt: 1,
              negPre: '-',
              negSuf: '',
              posPre: '',
              posSuf: ''
            },
            {
              gSize: 3,
              lgSize: 3,
              maxFrac: 2,
              minFrac: 2,
              minInt: 1,
              negPre: '-',
              negSuf: '\u00a0\u00a4',
              posPre: '',
              posSuf: '\u00a0\u00a4'
            }
          ]
        },
        id: 'de',
        pluralCat: function (n, opt_precision) {
          var i = n | 0;
          var vf = getVF(n, opt_precision);
          if (i == 1 && vf.v == 0) {
            return PLURAL_CATEGORY.ONE;
          }
          return PLURAL_CATEGORY.OTHER;
        }
      },
      fr: {
        DATETIME_FORMATS: {
          AMPMS: ['AM', 'PM'],
          DAY: [
            'Dimanche',
            'Lundi',
            'Mardi',
            'Mercredi',
            'Jeudi',
            'Vendredi',
            'Samedi'
          ],
          ERANAMES: ['Before Christ', 'Anno Domini'],
          ERAS: ['BC', 'AD'],
          FIRSTDAYOFWEEK: 6,
          MONTH: [
            'Janvier',
            'Février',
            'Mars',
            'Avril',
            'Mai',
            'Juin',
            'Juillet',
            'Août',
            'Septembre',
            'Octobre',
            'Novembre',
            'Décembre'
          ],
          SHORTDAY: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
          SHORTMONTH: [
            'janv',
            'févr',
            'mars',
            'avr',
            'mai',
            'juin',
            'juill',
            'août',
            'sept',
            'oct',
            'nov',
            'déc'
          ],
          WEEKENDRANGE: [5, 6],
          fullDate: 'EEEE, MMMM d, y',
          longDate: 'MMMM d, y',
          medium: 'MMM d, y h:mm:ss a',
          mediumDate: 'MMM d, y',
          mediumTime: 'h:mm:ss a',
          short: 'M/d/yy h:mm a',
          shortDate: 'M/d/yy',
          shortTime: 'h:mm a'
        },
        NUMBER_FORMATS: {
          CURRENCY_SYM: '/u20ac',
          DECIMAL_SEP: '.',
          GROUP_SEP: ',',
          PATTERNS: [
            {
              gSize: 3,
              lgSize: 3,
              maxFrac: 3,
              minFrac: 0,
              minInt: 1,
              negPre: '-',
              negSuf: '',
              posPre: '',
              posSuf: ''
            },
            {
              gSize: 3,
              lgSize: 3,
              maxFrac: 2,
              minFrac: 2,
              minInt: 1,
              negPre: '-\u00a4',
              negSuf: '',
              posPre: '\u00a4',
              posSuf: ''
            }
          ]
        },
        id: 'fr',
        pluralCat: function (n, opt_precision) {
          var i = n | 0;
          var vf = getVF(n, opt_precision);
          if (i == 1 && vf.v == 0) {
            return PLURAL_CATEGORY.ONE;
          }
          return PLURAL_CATEGORY.OTHER;
        }
      },
      hr: {
        DATETIME_FORMATS: {
          AMPMS: ['AM', 'PM'],
          DAY: [
            'nedjelja',
            'ponedjeljak',
            'utorak',
            'srijeda',
            '\u010detvrtak',
            'petak',
            'subota'
          ],
          ERANAMES: ['Prije Krista', 'Poslije Krista'],
          ERAS: ['pr. Kr.', 'p. Kr.'],
          FIRSTDAYOFWEEK: 6,
          MONTH: [
            'sije\u010dnja',
            'velja\u010de',
            'o\u017eujka',
            'travnja',
            'svibnja',
            'lipnja',
            'srpnja',
            'kolovoza',
            'rujna',
            'listopada',
            'studenoga',
            'prosinca'
          ],
          SHORTDAY: ['ned', 'pon', 'uto', 'sri', '\u010det', 'pet', 'sub'],
          SHORTMONTH: [
            'sij',
            'velj',
            'o\u017eu',
            'tra',
            'svi',
            'lip',
            'srp',
            'kol',
            'ruj',
            'lis',
            'stu',
            'pro'
          ],
          WEEKENDRANGE: [5, 6],
          fullDate: 'EEEE, d. MMMM y.',
          longDate: 'd. MMMM y.',
          medium: 'd. MMM y. HH:mm:ss',
          mediumDate: 'd. MMM y.',
          mediumTime: 'HH:mm:ss',
          short: 'dd.MM.y. HH:mm',
          shortDate: 'dd.MM.y.',
          shortTime: 'HH:mm'
        },
        NUMBER_FORMATS: {
          CURRENCY_SYM: 'kn',
          DECIMAL_SEP: ',',
          GROUP_SEP: '.',
          PATTERNS: [
            {
              gSize: 3,
              lgSize: 3,
              maxFrac: 3,
              minFrac: 0,
              minInt: 1,
              negPre: '-',
              negSuf: '',
              posPre: '',
              posSuf: ''
            },
            {
              gSize: 3,
              lgSize: 3,
              maxFrac: 2,
              minFrac: 2,
              minInt: 1,
              negPre: '-',
              negSuf: '\u00a0\u00a4',
              posPre: '',
              posSuf: '\u00a0\u00a4'
            }
          ]
        },
        id: 'hr',
        pluralCat: function (n, opt_precision) {
          var i = n | 0;
          var vf = getVF(n, opt_precision);
          if (
            (vf.v == 0 && i % 10 == 1 && i % 100 != 11) ||
            (vf.f % 10 == 1 && vf.f % 100 != 11)
          ) {
            return PLURAL_CATEGORY.ONE;
          }
          if (
            (vf.v == 0 &&
              i % 10 >= 2 &&
              i % 10 <= 4 &&
              (i % 100 < 12 || i % 100 > 14)) ||
            (vf.f % 10 >= 2 &&
              vf.f % 10 <= 4 &&
              (vf.f % 100 < 12 || vf.f % 100 > 14))
          ) {
            return PLURAL_CATEGORY.FEW;
          }
          return PLURAL_CATEGORY.OTHER;
        }
      },
      sl: {
        DATETIME_FORMATS: {
          AMPMS: ['AM', 'PM'],
          DAY: [
            'nedelja',
            'ponedeljek',
            'torek',
            'sreda',
            '\u010detrtek',
            'petek',
            'sobota'
          ],
          ERANAMES: ['Pred Kristusom', 'Po Kristusu'],
          ERAS: ['pr. Kr.', 'p. Kr.'],
          FIRSTDAYOFWEEK: 6,
          MONTH: [
            'januar',
            'februar',
            'marec',
            'april',
            'maj',
            'junij',
            'julij',
            'avgust',
            'september',
            'oktober',
            'november',
            'december'
          ],
          SHORTDAY: ['ned', 'pon', 'tor', 'sri', '\u010det', 'pet', 'sob'],
          SHORTMONTH: [
            'jan',
            'feb',
            'mar',
            'apr',
            'maj',
            'jun',
            'jul',
            'avg',
            'sep',
            'okt',
            'nov',
            'dec'
          ],
          WEEKENDRANGE: [5, 6],
          fullDate: 'EEEE, d. MMMM y.',
          longDate: 'd. MMMM y.',
          medium: 'd. MMM y. HH:mm:ss',
          mediumDate: 'd. MMM y.',
          mediumTime: 'HH:mm:ss',
          short: 'dd.MM.y. HH:mm',
          shortDate: 'dd.MM.y.',
          shortTime: 'HH:mm'
        },
        NUMBER_FORMATS: {
          CURRENCY_SYM: '\u20ac',
          DECIMAL_SEP: ',',
          GROUP_SEP: '.',
          PATTERNS: [
            {
              gSize: 3,
              lgSize: 3,
              maxFrac: 3,
              minFrac: 0,
              minInt: 1,
              negPre: '-',
              negSuf: '',
              posPre: '',
              posSuf: ''
            },
            {
              gSize: 3,
              lgSize: 3,
              maxFrac: 2,
              minFrac: 2,
              minInt: 1,
              negPre: '-',
              negSuf: '\u00a0\u00a4',
              posPre: '',
              posSuf: '\u00a0\u00a4'
            }
          ]
        },
        id: 'sl',
        pluralCat: function (n, opt_precision) {
          var i = n | 0;
          var vf = getVF(n, opt_precision);
          if (
            (vf.v == 0 && i % 10 == 1 && i % 100 != 11) ||
            (vf.f % 10 == 1 && vf.f % 100 != 11)
          ) {
            return PLURAL_CATEGORY.ONE;
          }
          if (
            (vf.v == 0 &&
              i % 10 >= 2 &&
              i % 10 <= 4 &&
              (i % 100 < 12 || i % 100 > 14)) ||
            (vf.f % 10 >= 2 &&
              vf.f % 10 <= 4 &&
              (vf.f % 100 < 12 || vf.f % 100 > 14))
          ) {
            return PLURAL_CATEGORY.FEW;
          }
          return PLURAL_CATEGORY.OTHER;
        }
      },
      uk: {
        DATETIME_FORMATS: {
          AMPMS: ['\u0434\u043f', '\u043f\u043f'],
          DAY: [
            '\u0441\u0443\u0431\u043e\u0442\u0430',
            '\u043d\u0435\u0434\u0456\u043b\u044f',
            '\u043f\u043e\u043d\u0435\u0434\u0456\u043b\u043e\u043a',
            '\u0432\u0456\u0432\u0442\u043e\u0440\u043e\u043a',
            '\u0441\u0435\u0440\u0435\u0434\u0430',
            '\u0447\u0435\u0442\u0432\u0435\u0440',
            '\u043f\u02bc\u044f\u0442\u043d\u0438\u0446\u044f'
          ],
          MONTH: [
            '\u0441\u0456\u0447\u043d\u044f',
            '\u043b\u044e\u0442\u043e\u0433\u043e',
            '\u0431\u0435\u0440\u0435\u0437\u043d\u044f',
            '\u043a\u0432\u0456\u0442\u043d\u044f',
            '\u0442\u0440\u0430\u0432\u043d\u044f',
            '\u0447\u0435\u0440\u0432\u043d\u044f',
            '\u043b\u0438\u043f\u043d\u044f',
            '\u0441\u0435\u0440\u043f\u043d\u044f',
            '\u0432\u0435\u0440\u0435\u0441\u043d\u044f',
            '\u0436\u043e\u0432\u0442\u043d\u044f',
            '\u043b\u0438\u0441\u0442\u043e\u043f\u0430\u0434\u0430',
            '\u0433\u0440\u0443\u0434\u043d\u044f'
          ],
          SHORTDAY: [
            '\u041d\u0434',
            '\u041f\u043d',
            '\u0412\u0442',
            '\u0421\u0440',
            '\u0427\u0442',
            '\u041f\u0442',
            '\u0421\u0431'
          ],
          SHORTMONTH: [
            '\u0441\u0456\u0447.',
            '\u043b\u044e\u0442.',
            '\u0431\u0435\u0440.',
            '\u043a\u0432\u0456\u0442.',
            '\u0442\u0440\u0430\u0432.',
            '\u0447\u0435\u0440\u0432.',
            '\u043b\u0438\u043f.',
            '\u0441\u0435\u0440\u043f.',
            '\u0432\u0435\u0440.',
            '\u0436\u043e\u0432\u0442.',
            '\u043b\u0438\u0441\u0442.',
            '\u0433\u0440\u0443\u0434.'
          ],
          fullDate: "EEEE, d MMMM y '\u0440'.",
          longDate: "d MMMM y '\u0440'.",
          medium: "d MMM y '\u0440'. HH:mm:ss",
          mediumDate: "d MMM y '\u0440'.",
          mediumTime: 'HH:mm:ss',
          short: 'dd.MM.yy HH:mm',
          shortDate: 'dd.MM.yy',
          shortTime: 'HH:mm'
        },
        NUMBER_FORMATS: {
          CURRENCY_SYM: '\u20b4',
          DECIMAL_SEP: ',',
          GROUP_SEP: '\u00a0',
          PATTERNS: [
            {
              gSize: 3,
              lgSize: 3,
              maxFrac: 3,
              minFrac: 0,
              minInt: 1,
              negPre: '-',
              negSuf: '',
              posPre: '',
              posSuf: ''
            },
            {
              gSize: 3,
              lgSize: 3,
              maxFrac: 2,
              minFrac: 2,
              minInt: 1,
              negPre: '-',
              negSuf: '\u00a0\u00a4',
              posPre: '',
              posSuf: '\u00a0\u00a4'
            }
          ]
        },
        id: 'uk',
        pluralCat: function (n, opt_precision) {
          var i = n | 0;
          var vf = getVF(n, opt_precision);
          if (vf.v == 0 && i % 10 == 1 && i % 100 != 11) {
            return PLURAL_CATEGORY.ONE;
          }
          if (
            vf.v == 0 &&
            i % 10 >= 2 &&
            i % 10 <= 4 &&
            (i % 100 < 12 || i % 100 > 14)
          ) {
            return PLURAL_CATEGORY.FEW;
          }
          if (
            (vf.v == 0 && i % 10 == 0) ||
            (vf.v == 0 && i % 10 >= 5 && i % 10 <= 9) ||
            (vf.v == 0 && i % 100 >= 11 && i % 100 <= 14)
          ) {
            return PLURAL_CATEGORY.MANY;
          }
          return PLURAL_CATEGORY.OTHER;
        }
      },
      hu: {
        DATETIME_FORMATS: {
          AMPMS: ['AM', 'PM'],
          DAY: [
            'vasárnap',
            'hétfő',
            'kedd',
            'szerda',
            'csütörtök',
            'péntek',
            'szombat'
          ],
          ERANAMES: ['Before Christ', 'Anno Domini'],
          ERAS: ['BC', 'AD'],
          FIRSTDAYOFWEEK: 6,
          MONTH: [
            'január',
            'február',
            'március',
            'április',
            'május',
            'június',
            'július',
            'augusztus',
            'szeptember',
            'október',
            'november',
            'december'
          ],
          SHORTDAY: ['vas', 'hét', 'kedd', 'sze', 'csüt', 'pén', 'szo'],
          SHORTMONTH: [
            'jan',
            'feb',
            'márc',
            'ápr',
            'máj',
            'jún',
            'júl',
            'aug',
            'szept',
            'okt',
            'nov',
            'dec'
          ],
          WEEKENDRANGE: [5, 6],
          fullDate: 'EEEE, MMMM d, y',
          longDate: 'MMMM d, y',
          medium: 'MMM d, y h:mm:ss a',
          mediumDate: 'MMM d, y',
          mediumTime: 'h:mm:ss a',
          short: 'M/d/yy h:mm a',
          shortDate: 'M/d/yy',
          shortTime: 'h:mm a'
        },
        NUMBER_FORMATS: {
          CURRENCY_SYM: 'ft',
          DECIMAL_SEP: '.',
          GROUP_SEP: ',',
          PATTERNS: [
            {
              gSize: 3,
              lgSize: 3,
              maxFrac: 3,
              minFrac: 0,
              minInt: 1,
              negPre: '-',
              negSuf: '',
              posPre: '',
              posSuf: ''
            },
            {
              gSize: 3,
              lgSize: 3,
              maxFrac: 2,
              minFrac: 2,
              minInt: 1,
              negPre: '-\u00a4',
              negSuf: '',
              posPre: '\u00a4',
              posSuf: ''
            }
          ]
        },
        id: 'hu',
        pluralCat: function (n, opt_precision) {
          var i = n | 0;
          var vf = getVF(n, opt_precision);
          if (i == 1 && vf.v == 0) {
            return PLURAL_CATEGORY.ONE;
          }
          return PLURAL_CATEGORY.OTHER;
        }
      },
      ro: {
        DATETIME_FORMATS: {
          AMPMS: ['AM', 'PM'],
          DAY: [
            'Duminică',
            'Luni',
            'Marți',
            'Miercuri',
            'Joi',
            'Vineri',
            'Sâmbătă'
          ],
          ERANAMES: ['Before Christ', 'Anno Domini'],
          ERAS: ['BC', 'AD'],
          FIRSTDAYOFWEEK: 6,
          MONTH: [
            'Ianuarie',
            'Februarie',
            'Martie',
            'Aprilie',
            'Mai',
            'Iunie',
            'Iulie',
            'August',
            'Septembrie',
            'Octombrie',
            'Noiembrie',
            'Decembrie'
          ],
          SHORTDAY: ['Dum', 'Lun', 'Mar', 'Mie', 'Joi', 'Vin', 'Sâm'],
          SHORTMONTH: [
            'Ian.',
            'Febr.',
            'Mart.',
            'Apr.',
            'Mai',
            'Iun.',
            'Iul.',
            'Aug.',
            'Sept.',
            'Oct.',
            'Nov.',
            'Dec.'
          ],
          WEEKENDRANGE: [5, 6],
          fullDate: 'EEEE, MMMM d, y',
          longDate: 'MMMM d, y',
          medium: 'MMM d, y h:mm:ss a',
          mediumDate: 'MMM d, y',
          mediumTime: 'h:mm:ss a',
          short: 'M/d/yy h:mm a',
          shortDate: 'M/d/yy',
          shortTime: 'h:mm a'
        },
        NUMBER_FORMATS: {
          CURRENCY_SYM: 'leu',
          DECIMAL_SEP: '.',
          GROUP_SEP: ',',
          PATTERNS: [
            {
              gSize: 3,
              lgSize: 3,
              maxFrac: 3,
              minFrac: 0,
              minInt: 1,
              negPre: '-',
              negSuf: '',
              posPre: '',
              posSuf: ''
            },
            {
              gSize: 3,
              lgSize: 3,
              maxFrac: 2,
              minFrac: 2,
              minInt: 1,
              negPre: '-\u00a4',
              negSuf: '',
              posPre: '\u00a4',
              posSuf: ''
            }
          ]
        },
        id: 'ro',
        pluralCat: function (n, opt_precision) {
          var i = n | 0;
          var vf = getVF(n, opt_precision);
          if (i == 1 && vf.v == 0) {
            return PLURAL_CATEGORY.ONE;
          }
          return PLURAL_CATEGORY.OTHER;
        }
      },
      ru: {
        DATETIME_FORMATS: {
          AMPMS: ['AM', 'PM'],
          DAY: [
            '\u0441\u0443\u0431\u0431\u043e\u0442\u0430',
            '\u0432\u043e\u0441\u043a\u0440\u0435\u0441\u0435\u043d\u044c\u0435',
            '\u043f\u043e\u043d\u0435\u0434\u0435\u043b\u044c\u043d\u0438\u043a',
            '\u0432\u0442\u043e\u0440\u043d\u0438\u043a',
            '\u0441\u0440\u0435\u0434\u0430',
            '\u0447\u0435\u0442\u0432\u0435\u0440\u0433',
            '\u043f\u044f\u0442\u043d\u0438\u0446\u0430'
          ],
          MONTH: [
            '\u044f\u043d\u0432\u0430\u0440\u044f',
            '\u0444\u0435\u0432\u0440\u0430\u043b\u044f',
            '\u043c\u0430\u0440\u0442\u0430',
            '\u0430\u043f\u0440\u0435\u043b\u044f',
            '\u043c\u0430\u044f',
            '\u0438\u044e\u043d\u044f',
            '\u0438\u044e\u043b\u044f',
            '\u0430\u0432\u0433\u0443\u0441\u0442\u0430',
            '\u0441\u0435\u043d\u0442\u044f\u0431\u0440\u044f',
            '\u043e\u043a\u0442\u044f\u0431\u0440\u044f',
            '\u043d\u043e\u044f\u0431\u0440\u044f',
            '\u0434\u0435\u043a\u0430\u0431\u0440\u044f'
          ],
          SHORTDAY: [
            '\u0432\u0441',
            '\u043f\u043d',
            '\u0432\u0442',
            '\u0441\u0440',
            '\u0447\u0442',
            '\u043f\u0442',
            '\u0441\u0431'
          ],
          SHORTMONTH: [
            '\u044f\u043d\u0432.',
            '\u0444\u0435\u0432\u0440.',
            '\u043c\u0430\u0440\u0442\u0430',
            '\u0430\u043f\u0440.',
            '\u043c\u0430\u044f',
            '\u0438\u044e\u043d\u044f',
            '\u0438\u044e\u043b\u044f',
            '\u0430\u0432\u0433.',
            '\u0441\u0435\u043d\u0442.',
            '\u043e\u043a\u0442.',
            '\u043d\u043e\u044f\u0431.',
            '\u0434\u0435\u043a.'
          ],
          fullDate: "EEEE, d MMMM y '\u0433'.",
          longDate: "d MMMM y '\u0433'.",
          medium: "d MMM y '\u0433'. H:mm:ss",
          mediumDate: "d MMM y '\u0433'.",
          mediumTime: 'H:mm:ss',
          short: 'dd.MM.yy H:mm',
          shortDate: 'dd.MM.yy',
          shortTime: 'H:mm'
        },
        NUMBER_FORMATS: {
          CURRENCY_SYM: '\u0440\u0443\u0431.',
          DECIMAL_SEP: ',',
          GROUP_SEP: '\u00a0',
          PATTERNS: [
            {
              gSize: 3,
              lgSize: 3,
              maxFrac: 3,
              minFrac: 0,
              minInt: 1,
              negPre: '-',
              negSuf: '',
              posPre: '',
              posSuf: ''
            },
            {
              gSize: 3,
              lgSize: 3,
              maxFrac: 2,
              minFrac: 2,
              minInt: 1,
              negPre: '-',
              negSuf: '\u00a0\u00a4',
              posPre: '',
              posSuf: '\u00a0\u00a4'
            }
          ]
        },
        id: 'ru',
        pluralCat: function (n, opt_precision) {
          var i = n | 0;
          var vf = getVF(n, opt_precision);
          if (vf.v == 0 && i % 10 == 1 && i % 100 != 11) {
            return PLURAL_CATEGORY.ONE;
          }
          if (
            vf.v == 0 &&
            i % 10 >= 2 &&
            i % 10 <= 4 &&
            (i % 100 < 12 || i % 100 > 14)
          ) {
            return PLURAL_CATEGORY.FEW;
          }
          if (
            (vf.v == 0 && i % 10 == 0) ||
            (vf.v == 0 && i % 10 >= 5 && i % 10 <= 9) ||
            (vf.v == 0 && i % 100 >= 11 && i % 100 <= 14)
          ) {
            return PLURAL_CATEGORY.MANY;
          }
          return PLURAL_CATEGORY.OTHER;
        }
      },
      nl: {
        DATETIME_FORMATS: {
          AMPMS: ['AM', 'PM'],
          DAY: [
            'Zondag',
            'Maandag',
            'Dinsdag',
            'Woensdag',
            'Donderdag',
            'Vrijdag',
            'Zaterdag'
          ],
          ERANAMES: ['Before Christ', 'Anno Domini'],
          ERAS: ['BC', 'AD'],
          FIRSTDAYOFWEEK: 6,
          MONTH: [
            'Januari',
            'Februari',
            'Maart',
            'April',
            'Mei',
            'Juni',
            'Juli',
            'Augustus',
            'September',
            'Oktober',
            'November',
            'December'
          ],
          SHORTDAY: ['Zo', 'Ma', 'Di', 'Wo', 'Do', 'Vr', 'Za'],
          SHORTMONTH: [
            'Jan',
            'Feb',
            'Mrt',
            'Apr',
            'Mei',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Okt',
            'Nov',
            'Dec'
          ],
          WEEKENDRANGE: [5, 6],
          fullDate: 'EEEE, MMMM d, y',
          longDate: 'MMMM d, y',
          medium: 'MMM d, y h:mm:ss a',
          mediumDate: 'MMM d, y',
          mediumTime: 'h:mm:ss a',
          short: 'd/M/yy h:mm a',
          shortDate: 'd/M/yy',
          shortTime: 'h:mm a'
        },
        NUMBER_FORMATS: {
          CURRENCY_SYM: '\u20ac',
          DECIMAL_SEP: '.',
          GROUP_SEP: ',',
          PATTERNS: [
            {
              gSize: 3,
              lgSize: 3,
              maxFrac: 3,
              minFrac: 0,
              minInt: 1,
              negPre: '-',
              negSuf: '',
              posPre: '',
              posSuf: ''
            },
            {
              gSize: 3,
              lgSize: 3,
              maxFrac: 2,
              minFrac: 2,
              minInt: 1,
              negPre: '-\u00a4',
              negSuf: '',
              posPre: '\u00a4',
              posSuf: ''
            }
          ]
        },
        id: 'nl',
        pluralCat: function (n, opt_precision) {
          var i = n | 0;
          var vf = getVF(n, opt_precision);
          if (i == 1 && vf.v == 0) {
            return PLURAL_CATEGORY.ONE;
          }
          return PLURAL_CATEGORY.OTHER;
        }
      },
      sv: {
        DATETIME_FORMATS: {
          AMPMS: ['AM', 'PM'],
          DAY: [
            'Söndag',
            'Måndag',
            'Tisdag',
            'Onsdag',
            'Torsdag',
            'Fredag',
            'Lördag'
          ],
          ERANAMES: ['Before Christ', 'Anno Domini'],
          ERAS: ['BC', 'AD'],
          FIRSTDAYOFWEEK: 6,
          MONTH: [
            'Januari',
            'Februari',
            'Mars',
            'April',
            'Maj',
            'Juni',
            'Juli',
            'Augusti',
            'September',
            'Oktober',
            'November',
            'December'
          ],
          SHORTDAY: ['sön', 'mån', 'tis', 'ons', 'tor', 'fre', 'lör'],
          SHORTMONTH: [
            'Jan',
            'Feb',
            'Mat',
            'Apr',
            'Maj',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Okt',
            'Nov',
            'Dec'
          ],
          WEEKENDRANGE: [5, 6],
          fullDate: 'EEEE, MMMM d, y',
          longDate: 'MMMM d, y',
          medium: 'MMM d, y h:mm:ss a',
          mediumDate: 'MMM d, y',
          mediumTime: 'h:mm:ss a',
          short: 'd/M/yy h:mm a',
          shortDate: 'd/M/yy',
          shortTime: 'h:mm a'
        },
        NUMBER_FORMATS: {
          CURRENCY_SYM: '\u20ac',
          DECIMAL_SEP: '.',
          GROUP_SEP: ',',
          PATTERNS: [
            {
              gSize: 3,
              lgSize: 3,
              maxFrac: 3,
              minFrac: 0,
              minInt: 1,
              negPre: '-',
              negSuf: '',
              posPre: '',
              posSuf: ''
            },
            {
              gSize: 3,
              lgSize: 3,
              maxFrac: 2,
              minFrac: 2,
              minInt: 1,
              negPre: '-\u00a4',
              negSuf: '',
              posPre: '\u00a4',
              posSuf: ''
            }
          ]
        },
        id: 'sv',
        pluralCat: function (n, opt_precision) {
          var i = n | 0;
          var vf = getVF(n, opt_precision);
          if (i == 1 && vf.v == 0) {
            return PLURAL_CATEGORY.ONE;
          }
          return PLURAL_CATEGORY.OTHER;
        }
      },
      sk: {
        DATETIME_FORMATS: {
          AMPMS: ['AM', 'PM'],
          DAY: [
            'nedeľa',
            'pondelok',
            'utorok',
            'streda',
            'štvrtok',
            'piatok',
            'sobota'
          ],
          ERANAMES: ['pred Kristom', 'po Kristovi'],
          ERAS: ['pred Kr.', 'po Kr.'],
          FIRSTDAYOFWEEK: 0,
          MONTH: [
            'január',
            'február',
            'marec',
            'apríl',
            'máj',
            'jún',
            'júl',
            'august',
            'september',
            'október',
            'november',
            'december'
          ],
          SHORTDAY: ['ne', 'po', 'ut', 'st', 'št', 'pi', 'so'],
          SHORTMONTH: [
            'jan',
            'feb',
            'mar',
            'apr',
            'máj',
            'jún',
            'júl',
            'aug',
            'sep',
            'okt',
            'nov',
            'dec'
          ],
          WEEKENDRANGE: [5, 6],
          fullDate: 'EEEE, d. MMMM y',
          longDate: 'd. MMMM y',
          medium: 'd. M. y H:mm:ss',
          mediumDate: 'd. M. y',
          mediumTime: 'H:mm:ss',
          short: 'd. M. y H:mm',
          shortDate: 'd. M. y',
          shortTime: 'H:mm'
        },
        NUMBER_FORMATS: {
          CURRENCY_SYM: '€',
          DECIMAL_SEP: ',',
          GROUP_SEP: ' ',
          PATTERNS: [
            {
              gSize: 3,
              lgSize: 3,
              maxFrac: 3,
              minFrac: 0,
              minInt: 1,
              negPre: '-',
              negSuf: '',
              posPre: '',
              posSuf: ''
            },
            {
              gSize: 3,
              lgSize: 3,
              maxFrac: 2,
              minFrac: 2,
              minInt: 1,
              negPre: '-',
              negSuf: ' \u00a4',
              posPre: '',
              posSuf: ' \u00a4'
            }
          ]
        },
        id: 'sk',
        pluralCat: function (n, opt_precision) {
          var i = n | 0;
          var vf = getVF(n, opt_precision);
          if (i == 1 && vf.v == 0) {
            return PLURAL_CATEGORY.ONE;
          }
          if (i >= 2 && i <= 4 && vf.v == 0) {
            return PLURAL_CATEGORY.FEW;
          }
          if (vf.v != 0) {
            return PLURAL_CATEGORY.MANY;
          }
          return PLURAL_CATEGORY.OTHER;
        }
      },
      fi: {
        DATETIME_FORMATS: {
          AMPMS: ['AM', 'PM'],
          DAY: [
            'Sunnuntai',
            'Maanantai',
            'Tiistai',
            'Keskiviikko',
            'Torstai',
            'Perjantai',
            'Lauantai'
          ],
          ERANAMES: ['Before Christ', 'Anno Domini'],
          ERAS: ['BC', 'AD'],
          FIRSTDAYOFWEEK: 6,
          MONTH: [
            'Tammikuu',
            'Helmikuu',
            'Maaliskuu',
            'Huhtikuu',
            'Toukokuu',
            'Kesäkuu',
            'Heinäkuu',
            'Elokuu',
            'Syyskuu',
            'Lokakuu',
            'Marraskuu',
            'Joulukuu'
          ],
          SHORTDAY: ['su', 'ma', 'ti', 'ke', 'to', 'pe', 'la'],
          SHORTMONTH: [
            'Tammi',
            'Helmi',
            'Maalis',
            'Huhti',
            'Touko',
            'Kesä',
            'Heinä',
            'Elo',
            'Syys',
            'Loka',
            'Marras',
            'Joulu'
          ],
          WEEKENDRANGE: [5, 6],
          fullDate: 'EEEE, MMMM d, y',
          longDate: 'MMMM d, y',
          medium: 'MMM d, y h:mm:ss a',
          mediumDate: 'MMM d, y',
          mediumTime: 'h:mm:ss a',
          short: 'd/M/yy h:mm a',
          shortDate: 'd/M/yy',
          shortTime: 'h:mm a'
        },
        NUMBER_FORMATS: {
          CURRENCY_SYM: '\u20ac',
          DECIMAL_SEP: '.',
          GROUP_SEP: ',',
          PATTERNS: [
            {
              gSize: 3,
              lgSize: 3,
              maxFrac: 3,
              minFrac: 0,
              minInt: 1,
              negPre: '-',
              negSuf: '',
              posPre: '',
              posSuf: ''
            },
            {
              gSize: 3,
              lgSize: 3,
              maxFrac: 2,
              minFrac: 2,
              minInt: 1,
              negPre: '-\u00a4',
              negSuf: '',
              posPre: '\u00a4',
              posSuf: ''
            }
          ]
        },
        id: 'fi',
        pluralCat: function (n, opt_precision) {
          var i = n | 0;
          var vf = getVF(n, opt_precision);
          if (i == 1 && vf.v == 0) {
            return PLURAL_CATEGORY.ONE;
          }
          return PLURAL_CATEGORY.OTHER;
        }
      },
      setLanguage: function (languageKey) {
        $translate.use(languageKey);
        angular.copy(this[languageKey], $locale);
        moment.locale(languageKey);
      }
    };

    function getDecimals(n) {
      n = n + '';
      var i = n.indexOf('.');
      return i == -1 ? 0 : n.length - i - 1;
    }

    function getVF(n, opt_precision) {
      var v = opt_precision;

      if (undefined === v) {
        v = Math.min(getDecimals(n), 3);
      }

      var base = Math.pow(10, v);
      var f = ((n * base) | 0) % base;
      return { v: v, f: f };
    }
  }
})();
